import * as React from 'react'

const CategoryAndDate = ({ category, publishDate, formattedPublishDate, className }) => (
  <div className={className}>
    {category?.title || 'No category'} / <time dateTime={publishDate}>{formattedPublishDate}</time>
  </div>
)

export default CategoryAndDate
